import { useRef } from "react";
import { StoryCard } from "./StoryCard";

interface Submission {
  id: number;
  title: string;
  username: string;
  like_count: number;
}

interface PromptSectionProps {
  submissions: Submission[];
  onStoryClick: (id: number) => void;
}

export function PromptSection({ submissions, onStoryClick }: PromptSectionProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (submissions.length === 0) {
    return <p className="no-submissions">No submissions yet. Be the first!</p>;
  }

  // Split submissions into pairs for two-row layout
  const pairs: [Submission, Submission | undefined][] = [];
  for (let i = 0; i < submissions.length; i += 2) {
    pairs.push([submissions[i], submissions[i + 1]]);
  }

  return (
    <div className="submissions-container">
      {submissions.length > 4 && (
        <button className="scroll-btn scroll-left" onClick={() => scroll("left")}>
          &lt;
        </button>
      )}
      <div className="submissions-scroll" ref={scrollRef}>
        {pairs.map(([top, bottom], idx) => (
          <div className="story-card-column" key={idx}>
            <StoryCard
              id={top.id}
              title={top.title}
              username={top.username}
              likeCount={top.like_count}
              onClick={() => onStoryClick(top.id)}
            />
            {bottom && (
              <StoryCard
                id={bottom.id}
                title={bottom.title}
                username={bottom.username}
                likeCount={bottom.like_count}
                onClick={() => onStoryClick(bottom.id)}
              />
            )}
          </div>
        ))}
      </div>
      {submissions.length > 4 && (
        <button className="scroll-btn scroll-right" onClick={() => scroll("right")}>
          &gt;
        </button>
      )}
    </div>
  );
}
